import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";
import { TaxExemptModel } from "@SupplyLand/Types/TaxExemptModels";

export interface UploadTaxExemptionFormModel extends ApiParameter {
    customerNumber: string;
    pdfStrings: string[];
    feinNumber: string;
    firstName: string;
    lastName: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    postalCode: string;
    phoneNumber: string;
    emailAddress: string;
    stateRegistrationNumber: string;
}

export interface UploadTaxExemptionFormResult {
    success: boolean;
    message: string;
}

const supplyLandUrl = "/api/v1/supplyland";

export const invalidAddressException = "Insite.Core.Exceptions.InvalidAddressException";

export function postCertificate(parameter: UploadTaxExemptionFormModel) {
    return post<UploadTaxExemptionFormModel, UploadTaxExemptionFormResult>(
        `${supplyLandUrl}/createcertificate`,
        parameter,
    );
}

export async function getTaxExemptStatus() {
    const taxExemptModel = await get<TaxExemptModel>(`${supplyLandUrl}/getcustomercertificates?customerNumber=test`);
    return taxExemptModel;
}
